import { Component, Input, OnInit, HostBinding, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GarantiasOpcionalesService } from '../../../../core/providers/services/garantias-opcionales/garantias-opcionales.service';
import { take, tap } from 'rxjs/operators';
import { GarantiasResModel } from '../../../../core/models/garantias.model';
import { Subject } from 'rxjs';
import { Numbers } from 'src/app/utils/constants';
import { ListaGarantiasInterface } from 'src/app/core/interfaces/presupuesto-guardar.interface';
import { GarantiaModelRes } from 'src/app/core/interfaces/garantias-res.interface';

@Component({
  selector: 'app-table-simple',
  templateUrl: './table-simple.component.html',
  styleUrls: ['./table-simple.component.scss']
})
export class TableSimpleComponent implements OnInit, OnDestroy {

  @Input() FORM_DATA: FormGroup;
  /**
   * @description Es la configuracion del formulario
   */
  @Input() DATA_CONFIG: any;

  @HostBinding('class.w_max') apply = true;
  insureSelected: any;
  garanteeData: ListaGarantiasInterface[] = [];
  garantiasInv: number[] = [Numbers.number10434, Numbers.number12802, Numbers.number12803, Numbers.number12804, Numbers.number12805];
  garantiasPet: number[] = [Numbers.number15301, Numbers.number15302, Numbers.number15303, Numbers.number15305, Numbers.number15306,
    Numbers.number15307, Numbers.number15308, Numbers.number15309, Numbers.number15310];

  finish = new Subject();
  /**
   * @description constructor
   * @params garanteeSrv
   */
  constructor(
    private garanteeSrv: GarantiasOpcionalesService
  ) {
    this.garanteeSrv =  garanteeSrv;
  }
/**
 * @description metodo de inicio
 */
  ngOnInit() {

    this.insureSelected = this.FORM_DATA.get(['insureSelected']).value.chosed;

    this.getGarantees();
    this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).valueChanges
      .pipe(
        // take(1),
        tap(el => {
          this.getGarantees();
        })
      ).subscribe();

    this.FORM_DATA.get([this.insureSelected, 'insuredsPlayRiskSports']).valueChanges
      .pipe(
        // take(1),
        tap(el => {
          this.getGarantees();
        })
      ).subscribe();
    if ((this.insureSelected === 'particularTravelAsistance' &&
        this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.idProducto !== '17084' ) ||
        this.insureSelected === 'individualTravelAsistance') {
      this.FORM_DATA.get([this.insureSelected, 'petInsureds']).valueChanges
        .pipe(
          // take(1),
          tap(el => {
            this.getGarantees();
          })
        ).subscribe();
     }
  }
  /**
   * @description metodo de fin
   */
  ngOnDestroy() {
    this.finish.next(true);
  }
 /**
  * @description recuperar garantias
  */
  getGarantees(): void {
    const ID: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.idProducto;
    const GUARANTEE_SELECTION_AUX: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).value;
    const VIAJEROS_INV: any = this.FORM_DATA.get([this.insureSelected, 'insuredsPlayRiskSports']).value;
    let PET_INSUREDS: any;
    if ((this.insureSelected === 'particularTravelAsistance' && ID !== '17084' ) || this.insureSelected === 'individualTravelAsistance') {
       PET_INSUREDS = this.FORM_DATA.get([this.insureSelected, 'petInsureds']).value;
    } else {
      PET_INSUREDS = {name: '', id: 0};
    }

    this.garanteeSrv.getGaranteeOptional(ID)
      .pipe(
        take(1),
        tap((e: any) => {
          let listGarantee: any[] = [];
          const MAPED: any = e.map(el => new GarantiasResModel(el));
          const ARR_GAR: ListaGarantiasInterface[] = [];
          const MAPED2: any[] = [];
          const IS18000: boolean = this.getGaranteeLimitMoreThan18000();

          listGarantee = this.getListGarantee(VIAJEROS_INV, PET_INSUREDS, MAPED, MAPED2);

          if (listGarantee.length > 0) {
            listGarantee.forEach(item => {
              const NUMBER_OF_INCREMENTS = item.impLimiteMaximo / item.impTramoLimite;
              const EXTEND_LIMIT: any = [{ name: '0', id: 0 }];
              for (let index = 1; index <= NUMBER_OF_INCREMENTS; index++) {
                EXTEND_LIMIT.push({ name: `${item.impTramoLimite * index}`, id: item.impTramoLimite * index });
              }
              item.extendLimit = EXTEND_LIMIT;
              if (this.garantiasInv.includes(item.idGarantia) || this.garantiasPet.includes(item.idGarantia)) {
                item.selectedExtend = item.impLimite;
              } else if (GUARANTEE_SELECTION_AUX.length > 0) {
                const AUX_VAL: any = GUARANTEE_SELECTION_AUX.filter(i => i.idGarantia === item.idGarantia);
                item.selectedExtend = 0;
                if (AUX_VAL.length > 0) { item.selectedExtend = AUX_VAL[0].Capital; }
              } else if (IS18000) {
                item.selectedExtend = item.impLimite;
              } else {
                item.selectedExtend = 0;
                if (item.indOpcional === false) { item.selectedExtend = item.impTramoLimite; }
              }
              if (!item.indOpcional && !item.indLimiteOpcional) {
                item.model = { name: `${item.impLimite}`};
              }
              item.model = { name: `${item.selectedExtend}` };
              ARR_GAR.push(item);
            });

            this.garanteeData = ARR_GAR;
            this.resetGaranteesInForm();
          } else {
            this.garanteeData = ARR_GAR;
            this.resetGaranteesInForm();
          }
        })
      ).subscribe();
  }
  /**
   * @description Límite de garantía más de 18000
   */
  getGaranteeLimitMoreThan18000(): boolean {
    let result = false;
    const MEDICAL_EXPENSES: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.name;
    const INSUREDS_PLAY_RISK_SPORTS: any = this.FORM_DATA.get([this.insureSelected, 'insuredsPlayRiskSports']).value.id;
    let NUMBER_PETS_INSUREDS: any;
    if ((this.insureSelected === 'particularTravelAsistance' &&
        this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.idProducto !== '17084' ) ||
        this.insureSelected === 'individualTravelAsistance') {
        NUMBER_PETS_INSUREDS = this.FORM_DATA.get([this.insureSelected, 'petInsureds']).value.id;
   } else {
        NUMBER_PETS_INSUREDS = 0;
   }

    // if (MEDICAL_EXPENSES === Numbers.number18000 && INSUREDS_PLAY_RISK_SPORTS > 0) {
    //   result = true;
    // }
    if ((this.insureSelected === 'individualTravelAsistance' && NUMBER_PETS_INSUREDS > 0) ||
    (this.insureSelected !== 'individualTravelAsistance' && MEDICAL_EXPENSES === Numbers.number18000 && INSUREDS_PLAY_RISK_SPORTS > 0)) {

      result = true;
    }
    return result;
  }
/**
 * @description actualizar datos
 * @params item
 * @params ev
 */
  updateData(item: any, ev: { value: { name: string, id: number } }): void {
    item.selectedExtend = ev.value.id;
    item.model = { name: `${item.selectedExtend}` };
    this.resetGaranteesInForm();
  }
/**
 * @description restaurar garantías
 */
  resetGaranteesInForm(): void {
    let chosedGars: ListaGarantiasInterface[] = [];
    const MEDICAL_EXPENSES: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.name;
    if (MEDICAL_EXPENSES === Numbers.number18000) {
      const COMPOUND_GARANTEES: any = this.compoundGarantee(this.garanteeData);
      chosedGars = COMPOUND_GARANTEES;
    } else {
      this.garanteeData.forEach(el => {
        if (el.selectedExtend > 0) {
          chosedGars.push(el);
        } else {
          if (this.garantiasInv.includes(el.idGarantia)) {
            chosedGars.push(el);
          }
        }
      });
      chosedGars = this.compoundGarantee(chosedGars);
    }
    this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).setValue(chosedGars);
  }
  /**
   * @description  garantía compuesta
   * @params gar
   */
  compoundGarantee(gar: any): ListaGarantiasInterface[] {
    return gar.map(el => {
      return {
        idGarantia: el.idGarantia,
        Num_opcion_Contratacion: el.num_opcion_Contratacion,
        Capital: el.selectedExtend
      };
    });
  }

/**
 * @description  Si es falso no es variable ni ampliable por ello se deshabilita
 * @params item
 */
  getIndLimiteOpcional(item: any): any | boolean {
    // Si es falso no es variable ni ampliable por ello se deshabilita
    return item.indLimiteOpcional;
  }
/**
 * @description recuperar datos garantía
 */
  getGaranteeData(): ListaGarantiasInterface[] {
    return this.garanteeData;
  }
/**
 * @description extender límite
 * @params item
 */
  getExtendLimit(item: any): { name: string, id: number } [] {
    if (!item.indOpcional && !item.indLimiteOpcional) {
      return [{name: `${item.impLimite}`, id: item.impLimite}];
    }
    if (item.idGarantia  === 10427) {
        return  item.extendLimit.filter((el: any) => el.id !== 0);
      }
    return item.extendLimit;
  }

  /**
   * Get the garantee list
   * @param VIAJEROS_INV winter travellers
   * @param PET_INSUREDS pets number
   * @param MAPED aux array
   * @param MAPED2 aux array
   * @returns - el listado de garantias
   */
  getListGarantee(VIAJEROS_INV: any, PET_INSUREDS: any, MAPED: any, MAPED2: any[]): GarantiaModelRes[] {
    let listGarantee: any[] = [];

    if ((VIAJEROS_INV.id === undefined || VIAJEROS_INV.id === 0) && (PET_INSUREDS.id === undefined || PET_INSUREDS.id === 0)) {
      MAPED.forEach((item: any) => {
            if (!this.garantiasInv.includes(item.idGarantia) && !this.garantiasPet.includes(item.idGarantia)) {
              MAPED2.push(item);
            }
          });
      listGarantee = MAPED2;
    } else if ((VIAJEROS_INV.id !== undefined || VIAJEROS_INV.id !== 0) && (PET_INSUREDS.id === undefined || PET_INSUREDS.id === 0)) {
      MAPED.forEach((item: any) => {
        if (!this.garantiasPet.includes(item.idGarantia)) {
          if (this.garantiasInv.includes(item.idGarantia)) {
            item.indOpcional = false;
          }
          MAPED2.push(item);
        }
      });

      listGarantee = MAPED2;
    } else {
      listGarantee = this.checkPetAndSportsGaratee(VIAJEROS_INV, PET_INSUREDS, MAPED, MAPED2);
    }

    return listGarantee;

  }

  /**
   * Get the garantee list when there are pets and winter travellers
   * @param VIAJEROS_INV winter travellers
   * @param PET_INSUREDS pets number
   * @param MAPED aux array
   * @param MAPED2 aux array
   * @returns garantee list
   */
  checkPetAndSportsGaratee(VIAJEROS_INV: any, PET_INSUREDS: any, MAPED: any, MAPED2: any[]): GarantiaModelRes[] {
    let listGarantee: any[] = [];

    if ((VIAJEROS_INV.id === undefined || VIAJEROS_INV.id === 0) && (PET_INSUREDS.id !== undefined || PET_INSUREDS.id !== 0)) {
      MAPED.forEach((item: any) => {
        if (!this.garantiasInv.includes(item.idGarantia)) {
          if (this.garantiasPet.includes(item.idGarantia)) {
            item.indOpcional = false;
          }
          MAPED2.push(item);
        }
      });
      listGarantee = MAPED2;
    } else {
      MAPED.forEach((item: any) => {
            if (this.garantiasInv.includes(item.idGarantia)) {
              item.indOpcional = false;
            }
          });
      MAPED.forEach((item: any) => {
            if (this.garantiasPet.includes(item.idGarantia)) {
              item.indOpcional = false;
            }
          });
      listGarantee = MAPED;
    }

    return listGarantee;
  }
}
